<template>
    
    <div class="main">
        <c-panel>
            <form-doenca :paramId="$route.params.id" v-on:onSubmitDoenca="onSubmitDoenca"></form-doenca>
        </c-panel>
    </div>
    
</template>
<script>

import formDoenca from "./form"

export default {
    methods:{

        onSubmitDoenca(){

            this.$router.push('/admin/dados-medicos/1');
        }
    },
    components:{ formDoenca }
}
</script>
